import { render, staticRenderFns } from "./SnapGrid.vue?vue&type=template&id=54d285e6"
import script from "./SnapGrid.vue?vue&type=script&lang=js"
export * from "./SnapGrid.vue?vue&type=script&lang=js"
import style0 from "./SnapGrid.vue?vue&type=style&index=0&id=54d285e6&prod&lang=scss"
import style2 from "./css/themes/default/snapgrid.scss?vue&type=style&index=2&prod&lang=scss&module=theme_default&external"
import style3 from "./css/themes/simple/snapgrid.scss?vue&type=style&index=3&prod&lang=scss&module=theme_simple&external"




function injectStyles (context) {
  
  this["theme_default"] = (style2.locals || style2)
this["theme_simple"] = (style3.locals || style3)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports